export const sendTrackingEvent = (eventName, eventBody) => {
  $.post(
    '/frontend-track',
    {
      '_json[]': {
        eventInfo: {
          eventName,
        },
        eventBody,
      },
    },
    function (response) {
      if (response && !response.success) {
        console.warn(`Failed to send tracking event ${eventName}`);
      }
    },
    'json'
  );
};

export const getCookie = (name) => {
  if (document.cookie) {
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`));

    if (match) {
      return match.split('=')[1];
    }

    return '';
  }

  return '';
};
